/**
 * Вертикаль недвижимости на выдаче.
 *
 * В отличие от {@link EDealType} и {@link FOfferType} это не битовая маска, а взаимоисключающий
 * набор значений: одна выдача принадлежит ровно одной вертикали.
 */
export enum EVertical {
  /** Не удалось определить вертикаль */
  Unexpected = 'unexpected',
  /** Вторичка */
  Secondary = 'secondary',
  /**
   * Смешанная выдача: продажа квартир без сужения до новостроек или вторички
   * (`offer_type=flat` без `object_type`).
   */
  Mixed = 'mixed',
  /** Новостройки */
  Newbuilding = 'newbuilding',
  /** Выдача внутри конкретного ЖК */
  ResidentialComplex = 'residentialComplex',
  /** Загородка */
  Suburban = 'suburban',
  /** Длительная аренда */
  RentLongterm = 'rentLongterm',
  /** Посуточная аренда */
  RentDaily = 'rentDaily',
  /** Коммерческая недвижимость */
  Commercial = 'commercial',
}
